import React from "react";
import { actAlertShow, actLoading, actLoadingEnd } from "../../../store/Actions";
import { commonLoadProvinces } from "../../../store/LoaderCommons/LoaderCommons";
import CheckboxSwitch from "../../../components/CheckboxSwitchComponent/CheckboxSwitch";
import { i18n } from "../../../lang/i18n";
import DC from "../../../common/DataConnector";
import Helpers from "../../../common/Helpers";
import './Address.css'
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
interface Props
{
    address: any,
    onClose: () => void,
    showBack: boolean
}
export default function CustomerAddresses(props: Props)
{
    const dispatch = useAppDispatch()
    const provinces = useAppSelector((state) => state.dics.provinces)
    const formSave = React.useRef<HTMLFormElement>(null)
    const [address, setAddress] = React.useState<any>(props.address)
    const [hasChanges, setHasChanges] = React.useState(false);
    const [cities, setCities] = React.useState<any[]>([])

    React.useEffect(() =>
    {
        (async function ()
        {
            actLoading(dispatch)
            await commonLoadProvinces(provinces, dispatch)

            if (address.province.code !== '')
                loadCities(address.province.code)
            actLoadingEnd(dispatch)
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onChange(fieldName: string, value: any)
    {
        const add: any = { ...address }
        if (fieldName === 'city' || fieldName === 'province') {
            add[fieldName].code = value;
        } else
            add[fieldName] = value
        setAddress(add)
        setHasChanges(true);
    }
    function onIsDefaultChange(e: any, ck: any)
    {
        const add: any = { ...address }
        add.isDefault = ck.active
        setAddress(add)
        setHasChanges(true);
        return true;
    }
    async function onChangeProvince(value: string)
    {
        onChange('province', value)
        loadCities(value)
    }
    async function loadCities(value: string)
    {
        setCities([])
        const cities = await DC.Get('/customer/common/provinces/' + value + '/cities', {});
        if (cities.wasOk) {
            setCities(cities.data)
        }
    }

    async function onSave(e: any)
    {
        e.preventDefault();
        var errors = Helpers.FormValidate(formSave.current);
        if (errors.isValidated) {
            const result = await DC.PostData('/customer/addresses/' + address.addressId, address);
            if (result.wasOk) {
                setHasChanges(false);
                props.onClose()

            } else {
                actAlertShow(dispatch, 'danger', i18n._MSG.ErrorSaveData);
            }
        } else {
            actAlertShow(dispatch, 'warning', i18n._MSG.CheckData);

        }
    }

    return (
        <div className="card-body">
            <div>
                <h5>{i18n.CustomerAddress.Title}</h5>
            </div>
            <div className="container">
                <form method="post" ref={formSave}>
                    <div className="form-group row">
                        <label className="col-12 col-form-label">*{i18n.CustomerAddress.ContactFullName}</label>
                        <div className="col-12">
                            <input name="contactFullName" type="text" className="form-control" placeholder={i18n.CustomerAddress.ContactFullName}
                                onChange={(e: any) => { onChange('contactFullName', e.target.value); }}
                                value={address.contactFullName} required />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-12 col-form-label">*{i18n.CustomerAddress.ContactPhone}</label>
                        <div className="col-12">
                            <input name="contactPhone" type="text" className="form-control" placeholder={i18n.CustomerAddress.ContactPhone}
                                onChange={(e: any) => { onChange('contactPhone', e.target.value); }}
                                value={address.contactPhone} required minLength={9} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-12 col-form-label">*{i18n.CustomerAddress.AddressLine1}</label>
                        <div className="col-12">
                            <input name="addressLine1" type="text" className="form-control" placeholder={i18n.CustomerAddress.AddressLine1Info}
                                onChange={(e: any) => { onChange('addressLine1', e.target.value); }}
                                value={address.addressLine1} required={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-12 col-form-label">{i18n.CustomerAddress.AddressLine2}</label>
                        <div className="col-12">
                            <input name="addressLine2" type="text" className="form-control" placeholder={i18n.CustomerAddress.AddressLine2Info}
                                onChange={(e: any) => { onChange('addressLine2', e.target.value); }}
                                value={address.addressLine2} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-12 col-form-label">*{i18n.CustomerAddress.AddressProvince}</label>
                        <div className="col-12">
                            <select name="province.code" className="form-control" value={address.province.code} onChange={(e: any) =>
                            {
                                onChangeProvince(e.target.value)
                            }} required={true}>
                                <option value=""></option>
                                {provinces.list.map((item: any, index: number) => (
                                    <option value={item.code} key={index}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-12 col-form-label">*{i18n.CustomerAddress.AddressCity}</label>
                        <div className="col-12">
                            <select name="city.code" className="form-control" value={address.city.code} onChange={(e: any) =>
                            {
                                onChange('city', e.target.value)
                            }} required>
                                <option value=""></option>
                                {cities.map((item: any, index: number) => (
                                    <option value={item.code} key={index}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-12 col-form-label">*{i18n.CustomerAddress.AddressCP}</label>
                        <div className="col-12">
                            <input name="cp" type="text" className="form-control" placeholder={i18n.CustomerAddress.AddressCP}
                                onChange={(e: any) => { onChange('cp', e.target.value); }}
                                value={address.cp} required minLength={4} maxLength={5} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-12 col-form-label">*{i18n.CustomerAddress.DefaultAddress}</label>
                        <div className="col-sm-4">
                            <CheckboxSwitch conf={{
                                fieldName: 'isDefault',
                                textActive: i18n._Labels.Yes,
                                textDeactivate: i18n._Labels.No,
                                active: address.isDefault
                            }} onChange={onIsDefaultChange} />
                        </div>
                    </div>
                    {hasChanges && <div className="text-center">
                        <button className="btn btn-warning" onClick={onSave}>
                            {i18n._BTNs.Save}
                        </button>
                    </div>}
                </form>
            </div>

            {props.showBack && <label className="btn-back link-btn btn-fixed-lb" onClick={props.onClose}
            ><i className="fa fa-arrow-left" /> {i18n._BTNs.Back}</label>}
            <br /><br />
        </div>
    );
}